export enum TextFieldType {
  TEXT = "text",
  NUMBER = "number",
  PHONE = "tel",
  EMAIL = "email",
  PASSWORD = "password",
}